import React, { useState,useEffect} from 'react';
import {Grid2, Paper,Pagination,Button } from '@mui/material';
import { StyledTextField } from '../StyledMUIComps';
import UmbrellaRainAnimation from './UmbrellaRainAnimation';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import './qslgallery.css'
import Title from './Title';

function QSLGallery() {
        const [startEndNum,setStartEndNum] = useState([1,10])
        const [qslData, setQSLData] = useState([])
        const recordsPerPage = 10; // 每页记录数
        const totalRecords = 80; // 总记录数
        const [opacity, setOpacity] = useState(0);
        const [loading,setLoading] = useState(false)
        const [issearch,setIsSearch] = useState(false)
        const [searchFor,setSearchFor] = useState('')
        const [resultsCount,setResultCount] = useState('')
        const [showNotice,setShowNotice] = useState(false)
        const totalPages = Math.ceil(totalRecords / recordsPerPage);
    
        useEffect(() => {
          getQSLs()
        }, [startEndNum]);

        useEffect(() => {
          let timer;
          if (loading) {
            setOpacity(0); // 重置透明度为 0
            timer = setTimeout(() => {
              setOpacity(1); // 在 25 秒后设置透明度为 1
            }, 25000); // 25 秒
          }
          return () => clearTimeout(timer); // 清理计时器
        }, [loading]); // 监听 loading 状态
        
        const getQSLs = async () => {
          setLoading(true); // 开始加载
          try {
              const formData = new URLSearchParams();
              formData.append('start', startEndNum[0]);
              formData.append('end', startEndNum[1]);

              const res = await fetch('https://api.sadatsunemyspace.uk/api/getqsls', {
                  method: 'POST',
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: formData.toString()
              });
              const { data } = await res.json();
              setQSLData(data);
          } catch (error) {
              console.error("Error fetching QSL pictures:", error);
          } finally {
              setLoading(false); // 加载完成
          }
        };

        const searchQSLs = async () => {
          setLoading(true); // 开始加载
          setIsSearch(true)
          try {
              const formData = new URLSearchParams();
              formData.append('condition', searchFor);
              console.log(searchFor)
              const res = await fetch('https://api.sadatsunemyspace.uk/api/searchqsls', {
                  method: 'POST',
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: formData.toString()
              });
              const { data } = await res.json();
              setQSLData(data);
              setResultCount(data.length+' found')
          } catch (error) {
              console.error("Error fetching QSL pictures:", error);
          } finally {
              setLoading(false); // 加载完成
          }
        };

        const handlePageChange = (event, page) => {
            // 根据页码计算起始和结束编号
            const start = (page - 1) * recordsPerPage + 1;
            const end = Math.min(page * recordsPerPage, totalRecords); // 确保结束编号不超过总记录数
            setStartEndNum([start, end]);
        };
        
        const handleSearchContent = (event) => {
          setSearchFor(event.target.value)
        }

    return (
    <div>
        <Title title={'QSL Gallery'}></Title>
        
        <p className='nekopara'>
              Here listed some QSL cards, eQSLs or verification letters I collected since 2016. Not all QSLs listed here because I usually gets 50-60 QSLs each year. That's a great job
              for me to digitalize all QSL cards and manage a database for them.
        </p>
        <div className='searchbox' style={{
          paddingBottom: (!issearch && !showNotice) ? '20px' : '0px'
        }}>
          <StyledTextField size='small' label="Station you want to find" onChange={handleSearchContent} value={searchFor}></StyledTextField>
          <Button variant='contained' className='searchqsl'sx={{
                backgroundColor:'rgba(188,71,77 ,1)',
            }}
              onClick={()=>{
                setShowNotice(false)
                if(issearch === false){
                  if(searchFor == ''){
                    setShowNotice(true)
                  }else{
                    searchQSLs()
                  }
                }else{
                  setIsSearch(false)
                  setSearchFor('')
                  setResultCount('')
                  getQSLs()
                }
              }}
            >
              <SearchRoundedIcon sx={{display: issearch ? 'none' : 'block'}}/>
              <CloseRoundedIcon sx={{display: issearch ? 'block' : 'none'}}/>
            </Button>
        </div>
        <p style={{
          fontFamily:'comicregular',
          color:'rgba(188,71,77 ,1)',
          display: showNotice ? 'block' : 'none'
        }}>
          Search field shouldn't be empty!
        </p>
        <p style={{
          fontFamily:'comicbold',
          fontSize:'large',
          color:'gray',
          display: issearch ? 'block' : 'none'
        }}>
          {resultsCount}
        </p>
        
        <Grid2
          container
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: '1fr 1fr',
            },
            gap: 4,
          }}
        >
        {loading ? (
          <div style={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'center', }}>
            <UmbrellaRainAnimation transparent={opacity} />
          </div>
        ) : (
          qslData.length > 0 ? (
            qslData.map((qsl, index) => (
              <Grid2 item xs={12} md={6}>
                <Paper className='qslcontainer' elevation={5}>
                  <img className='qslpic' src={`https://sadatsunemyspace.uk${qsl.dataside}`} alt={`QSL ${index}`} />
                  <img className='qslpic' src={`https://sadatsunemyspace.uk${qsl.backside}`} alt={`QSL ${index}`} />
                  <center>
                    <p style={{fontFamily:'comicbold'}}>Station name:<br />{qsl.name}</p>
                  </center>
                </Paper>
              </Grid2>
            ))
          ) : (
            <center style={{width:'100%'}}>
              <p style={{ fontFamily: 'comicbold', fontSize: 'x-large' }}>No QSL pictures available.</p>
              <p style={{ fontFamily: 'comicbold', fontSize: 'large',color:'gray', 
                visibility: issearch ? 'collapse' : 'visible'
              }}>
                Reasons:
                <br></br>
                · Network error
                <br></br>
                · Database error
                <br></br>
                Please wait and try again. If problem not solved, please email to us. Many thanks.
              </p>
            </center>
          )
        )}        

      </Grid2>
      <center>
        <Pagination
          className='pagina'
          count={totalPages} 
          variant="outlined"
          shape="rounded"
          onChange={handlePageChange}
          sx={{
            visibility: issearch ? 'collapse' : 'visible',
            '& .MuiPagination-ul': {
              justifyContent: 'center',
            },
            '& .MuiPaginationItem-root': {
              fontSize: {
                xs: '0.6rem',
                sm: '0.8rem',
              },
              minWidth: {
                xs: '24px',
                sm: '28px',
              },
              height: {
                xs: '24px',
                sm: '28px',
              },
              padding: {
                xs: '2px',
                sm: '4px',
              },
            },
          }}
        />
      </center>
    </div>
  );
}

export default QSLGallery;
